import React, {useEffect, useState} from "react";
import DaysLimitType from "@SearchResults/features/dateSlick/types/DaysLimit.type";
import createNewSliderDates from "@SearchResults/features/dateSlick/functions/createNewSliderDates";
import DateSlickSlide from "@SearchResults/features/dateSlick/components/DateSlickSlide";
import Row from "@Containers/components/Row";
import DateSlickArrow from "@SearchResults/features/dateSlick/components/DateSlickArrow";
import useSelectNewSearchDate from "@SearchResults/features/dateSlick/hooks/useSelectNewSearchDate";
import useIsMobile from "@Hooks/selector/useIsMobile";
import useMoveSlider from "@SearchResults/features/dateSlick/hooks/useMoveSlider";

interface DateSlickProps {
    /** Date for which search is executed */
    date: string,
    isReturn: boolean,
}

function DateSlick({date, isReturn}: DateSlickProps) {
    const isMobile = useIsMobile()

    const [
        daysLimit,
        setDaysLimit,
    ] = useState<DaysLimitType>({min: -15, max: 15})

    const [
        centralDate,
        setCentralDate,
    ] = useState<Date | string>(date)

    const [
        datesInSlider,
        setDatesInSlider,
    ] = useState(createNewSliderDates(date, daysLimit))

    const {
        sliderRef,
        centralDateRef,
        moveSliderRight,
        moveSliderLeft,
        displayLeftArrow,
    } = useMoveSlider({
        daysLimit,
        setDaysLimit,
        setDatesInSlider,
        centralDate,
    })

    useEffect(() => {
        setCentralDate(date)
    }, [date])

    const {onClick} = useSelectNewSearchDate(isReturn)

    return (
        <Row className="datestrip" center>
            {!isMobile && displayLeftArrow && (
                <DateSlickArrow
                    customClassName="slick-prev"
                    orientation="left"
                    click={moveSliderLeft}
                />
            )}
            <div className="gb--row datestrip__track" ref={sliderRef}>
                {datesInSlider.map((dateToDisplay) => (
                    <DateSlickSlide
                        key={dateToDisplay.toDateString()}
                        date={dateToDisplay}
                        isReturn={isReturn}
                        searchedDate={date}
                        selectNewSearchDate={onClick}
                        centralDateRef={centralDateRef}
                    />
                ))}

            </div>
            {!isMobile && (
                <DateSlickArrow
                    customClassName="slick-next"
                    orientation="right"
                    click={moveSliderRight}
                />
            )}
        </Row>
    )
}

export default DateSlick